/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".card-body[_ngcontent-%COMP%]{padding:50px 100px}.invaild-feedback-select[_ngcontent-%COMP%]{width:100%;margin-top:.25rem;font-size:80%;color:#d22929}.ng-select-container[_ngcontent-%COMP%]{border-color:#d22929!important}\n/*# sourceMappingURL=modal-general-information.component.css.map*/"];
export { styles as styles };
